import { defineComponent as _defineComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'CheckoutLegalEntity',
  props: {
  formdata: {
    type: Object,
  },
  choices: {
    type: Object,
  },
  predefinedPhoneCode: {
    type: Object,
  },
  errors: {
    type: Object,
  },
},
  emits: ['vat:reset'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props

const emit = __emit

const __returned__ = { props, emit }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})